import { useAppSelector } from '../../../Hooks/useAppSelector'

export const useShipmentFiltersSelector = () => {
  return useAppSelector((state) => state.shipmentFilters.filters)
}
